import(/* webpackMode: "eager" */ "/app/projects/web-dxp-ui/src/app/[hostname]/error.tsx");
